/**
 * メンテナンスモードのフラグ。
 *
 * true の間はトップページの入力フォームを閉じ、「メンテナンス中です」の案内を表示する。
 * フォームの action も無効化されるため、直接 POST されてもユーザー入力は保存されない。
 *
 * 背景: SendGrid 解約に伴い、新規の画像生成受付を停止するため。
 * @see https://github.com/monicle/chara-tsuku-ai/issues/2
 */
export const IS_MAINTENANCE = true;

/** メンテナンス案内ブロックの id（ヒーローのボタンからのアンカー先） */
export const MAINTENANCE_NOTICE_ID = "maintenance";
